import {DataTestAttrs, getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import {Point} from 'util/geometry/GeometryConstants';

export default function Line({
  dataTestAttrs,
  endPoint,
  startPoint,
  stroke,
  strokeDasharray,
  strokeLinecap,
  strokeWidth,
}: {
  dataTestAttrs?: DataTestAttrs;
  endPoint: Point;
  startPoint: Point;
  stroke: string;
  strokeDasharray?: string;
  strokeLinecap?: 'butt' | 'round' | 'square' | 'inherit';
  strokeWidth: number;
}): JSX.Element {
  return (
    <path
      {...getTestProps(dataTestAttrs)}
      d={['M', startPoint.x, startPoint.y, 'L', endPoint.x, endPoint.y].join(' ')}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeDasharray={strokeDasharray}
      strokeLinecap={strokeLinecap}
    />
  );
}
